<template>
  <!-- <div class="mapstyle boxall"> -->
  <!-- <div class="title">市场详情</div> -->
  <div class="mapbox">
    <div class="bg-image">
      <div class="map-charts" ref="chartsDOM"></div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'EcommerceDetail',

  data() {
    return {}
  }
}
</script>

<style scoped>
.mapbox {
  height: 100%;
  padding: 16px;
}
/* 
.bg-image {
  width: 100%;
  height: 100%;
  background: url('../assets/images/map_bg.png') no-repeat center center;
  background-size: cover;
  border-radius: 12px;
} */

.map-charts {
  height: 100%;
  width: 100%;
}
</style>
